export default "__VITE_ASSET__jUjrPxU9__"